/* eslint-disable no-nested-ternary */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { dispatch } from 'd3-dispatch';

import widgetWrapper from './widgetWrapper';

import {
  formatTime,
  formatTimestamp,
  renderSparkline,
  formatValue,
} from './widgetUtils';

import './ErrorChangeWidget.scss';

class ErrorChangeWidget extends Component {

  static propTypes = {
    title: PropTypes.string,
    subtitle: PropTypes.string,
    details: PropTypes.string,
    timestamp: PropTypes.string,
    className: PropTypes.string,
    hideAffected: PropTypes.bool,
  };

  static defaultProps = {
    title: '',
    subtitle: '',
    details: '',
    timestamp: '',
    className: '',
    hideAffected: false,
  };

  constructor(...args) {
    super(...args);
    this.doD3Rendering = renderSparkline.bind(this);
    this.chartRef = React.createRef();
    this.dispatcher = dispatch('pointenter', 'pointleave');
    this.dispatcher.on('pointenter', (d) => {
      this.setState({
        hover: {
          fake: d.fake,
          value: d.fake ? NaN : d.value,
          affectedValue: d.fake ? NaN : d.affectedCount,
          key: d.key,
        },
      });
    });
    this.dispatcher.on('pointleave', (_d) => {
      this.setState({ hover: null });
    });
  }

  state = { hover: null };

  componentDidMount() {
    window.addEventListener('resize', this.doD3Rendering);
    this.doD3Rendering();
  }

  componentDidUpdate(_prevProps, _prevState) {
    this.doD3Rendering();
  }

  render() {
    // Apply some default formatting.
    const {
      title = '',
      subtitle = '',
      details = '',
      timestamp = '',
      className = '',
      hideAffected = false,
    } = this.props;

    const clean = Object.assign({
      format: '.0%',
      smallFormat: '.1%',
      hideChangeValue: true,
    }, this.props);

    function pctChange(baseline, metric) {
      return (metric - baseline) / baseline;
    }

    return (
      <div className={`widget-threshold-colors ErrorChangeWidget ${className}`}>
        <div className="header">
          <div className="title">{title}</div>
          <div className="subtitle">{subtitle}</div>
        </div>
        <div className="content">
          <div className="content-wrapper">
            <div className="value">
              {
              hideAffected // eslint-disable-line react/prop-types
                ? (this.state.hover === null
                  ? formatValue(clean.value, clean.format, clean.smallFormat)
                  : formatValue(this.state.hover.value, clean.format, clean.smallFormat))
                : (this.state.hover === null
                  ? formatValue(clean.value, clean.format, clean.smallFormat)
                  : (this.state.hover.fake ? '-' : formatValue(
                    pctChange(clean.series.baseline, this.state.hover.value),
                    clean.format,
                    clean.smallFormat,
                  )
                  )
                )
            }
            </div>
            <div className="affectedValue">
              {
              hideAffected || className === 'empty'
                ? '-'
                : (
                  this.state.hover === null
                    ? `${clean.affected} DEVICE${clean.affected === 1 ? '' : 'S'}`
                    : (this.state.hover.fake
                      ? '-'
                      : `${this.state.hover.affectedValue} DEVICE${this.state.hover.affectedValue === 1 ? '' : 'S'}`)
                )
              }
            </div>
            <div className="sparkline-wrapper">
              <svg className="sparkline-svg" ref={this.chartRef} />
            </div>
          </div>
        </div>
        <div className="footer">
          <div className="details">
            {
              this.state.hover === null
                ? details
                : formatTime(this.state.hover.key)
            }
          </div>
          <div className="timestamp">{formatTimestamp(timestamp)}</div>
        </div>
      </div>
    );
  }
}

export default widgetWrapper(ErrorChangeWidget);
